// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:59:42

export default {
  "id": "fight-to-the-end",
  "slug": "fight-to-the-end",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/bca8524a24d148b99045af5b19d18b32-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/bca8524a24d148b99045af5b19d18b32/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fight to the end",
      "description": "Players control a protagonist, an assault soldier, who needs to keep moving and fend off enemy attacks during the battle to survive until the end. Each time the protagonist levels up, the player can choose one of three randomly offered buffs, which are divided into skill - type and bonus - type. Skill - type buffs allow the protagonist to add or enhance skills, while bonus - type buffs are related to the character. ",
      "instructions": "Players control a protagonist, an assault soldier, who needs to keep moving and fend off enemy attacks during the battle to survive until the end.\nMobile devices:\nUse rocker controls to move.\nDesktop devices:\nUse the W, A, S, D keys to move.",
      "genres": [
        ".IO",
        "Battle"
      ],
      "tags": [
        "battlefield",
        "fighting",
        "guns",
        "survival",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "战斗至最后一刻",
      "description": "玩家控制一位主角，一名突击士兵，在战斗中需要不断移动并抵御敌人的攻击以生存到战斗结束。每次主角升级时，玩家可以从三个随机提供的增益效果中选择一个，这些增益效果分为技能类和奖励类。技能类增益效果允许主角添加或增强技能，而奖励类增益效果与角色相关。",
      "instructions": "玩家控制一位主角，一名突击士兵，在战斗中需要不断移动并抵御敌人的攻击，以生存到战斗结束。\n移动设备：\n使用摇杆控制移动。\n桌面设备：\n使用W、A、S、D键移动。",
      "genres": [
        ".IO",
        "战斗"
      ],
      "tags": [
        "战场",
        "战斗",
        "枪械",
        "生存",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "戰鬥至終結",
      "description": "玩家操控主角，一名突擊士兵，在戰鬥中必須不停地移動並擊退敵人攻擊以生存到最後。每次主角升級時，玩家可以選擇三個隨機提供的增益效果之一，這些增益效果分為技能型和非技能型。技能型增益效果允許主角添加或強化技能，而非技能型增益效果則與角色相關。",
      "instructions": "玩家操控主角，一名突擊士兵，需要在戰鬥中不斷移動並擊退敵人攻擊，以生存到最後。\n行動裝置：\n使用搖桿控制移動。\n桌面裝置：\n使用 W、A、S、D 鍵來移動。",
      "genres": [
        ".IO",
        "戰鬥"
      ],
      "tags": [
        "戰場",
        "作戰",
        "槍械",
        "生存",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "戰至最後",
      "description": "玩家操控一個主角，一個突擊士兵，在戰鬥中需要不斷移動並擊退敵人攻擊以生存至最後。每次主角升級時，玩家可以選擇三個隨機提供的增益效果中之一，這些增益效果分為技能型及加成型。技能型增益效果讓主角能夠增加或提升技能，而加成型增益效果則與角色相關。",
      "instructions": "玩家操控主角，一名突擊士兵，需要在戰鬥中持續移動並擊退敵人攻擊，以生存至最後。\n行動裝置：\n使用搖桿控制移動。\n桌面裝置：\n使用 W、A、S、D 鍵移動。",
      "genres": [
        ".IO",
        "戰鬥"
      ],
      "tags": [
        "戰場",
        "戰鬥",
        "槍械",
        "生存",
        "武器"
      ]
    },
    "ja": {
      "title": "最後まで戦う",
      "description": "プレイヤーは主人公である突撃兵を操作し、戦闘中に常に動き回り敵の攻撃を防ぎながら生き延びる必要があります。主人公がレベルアップするたびに、ランダムに提供される3つのバフのうち1つを選択できます。これらのバフはスキルタイプとボーナスタイプに分かれており、スキルタイプのバフは主人公にスキルを追加または強化することを許可し、ボーナスタイプのバフはキャラクターに関連しています。",
      "instructions": "プレイヤーは主人公である突撃兵士を操作し、戦闘中に敵の攻撃を防ぎながら生き延びるまで移動を続けなければならない。\nモバイルデバイス：\nロッカーコントロールを使用して移動してください。\nデスクトップデバイス：\nW、A、S、Dキーを使用して移動してください。",
      "genres": [
        ".IO",
        "バトル"
      ],
      "tags": [
        "バトルフィールド",
        "戦闘",
        "銃",
        "サバイバル",
        "武器"
      ]
    },
    "ko": {
      "title": "최후까지 싸워라",
      "description": "플레이어는 전투 중 적의 공격을 방어하면서 생존할 수 있도록 움직이고 있는 공격병 주인공을 제어합니다. 주인공이 레벨업할 때마다, 플레이어는 기술형과 보너스형으로 나뉜 세 가지 랜덤으로 제공되는 버프 중 하나를 선택할 수 있습니다. 기술형 버프는 주인공이 기술을 추가하거나 강화할 수 있게 하며, 보너스형 버프는 캐릭터와 관련이 있습니다.",
      "instructions": "플레이어는 전투 중 적의 공격을 피하면서 살아남기 위해 끊임없이 움직이고 있는 공격병 주인공을 제어합니다.\n모바일 장치:\n로커 컨트롤을 사용하여 이동하세요.\n데스크톱 장치:\nW, A, S, D 키를 사용하여 이동하세요.",
      "genres": [
        ". IO",
        "전투"
      ],
      "tags": [
        "전장",
        "전투",
        "총",
        "생존",
        "무기"
      ]
    },
    "fr": {
      "title": "Combattre jusqu'au bout",
      "description": "Les joueurs contrôlent un protagoniste, un soldat d'assaut, qui doit rester en mouvement et se défendre contre les attaques ennemies pendant la bataille pour survivre jusqu'à la fin. À chaque fois que le protagoniste niveau up, le joueur peut choisir l'un des trois buffs offerts au hasard, qui sont divisés en buffs de type compétence et buffs de type bonus. Les buffs de type compétence permettent au protagoniste d'ajouter ou d'améliorer des compétences, tandis que les buffs de type bonus sont liés au personnage.",
      "instructions": "Les joueurs contrôlent un protagoniste, un soldat d'assaut, qui doit rester en mouvement et se défendre contre les attaques ennemies pendant la bataille pour survivre jusqu'à la fin.\nDispositifs mobiles :\nUtilisez les commandes de bascule pour vous déplacer.\nDispositifs de bureau :\nUtilisez les touches W, A, S, D pour vous déplacer.",
      "genres": [
        ".IO",
        "Bataille"
      ],
      "tags": [
        "bataille",
        "combat",
        "armes à feu",
        "survie",
        "armes"
      ]
    }
  }
};
